export enum Impulso {
    INDIVIDUAL = 1,
    GRUPAL = 4,
    PUBLICO = 3,
    EDUCATIVO = 2,
}
export enum Params {
    COUNTRIES = 0,//Id default para guardar en el local storage 
    DOCUMENT_TYPE = 1,
    ETHNIC_IDENTITY = 3,
    GENDER_IDENTITY = 5,
    LOCALITIES = 18,
    NEIGHBORHOODS = 82,
    DIFFERENTIAL_POPULATION_GROUPS = 179,
    EDUCATIONAL_LEVEL = 181,
    FIELDS = 185,
    AREAS = 186, //Cambio de id segun produccion
    SUB_FIELDS = 187,
    SUB_AREAS = 188,
    SEX = 189,
    SEXUAL_ORIENTATION = 190,
    DISABILITY_TYPE = 191,
    AGE_GROUPS = 192,
    STREET_HABITABILITY = 193,
    CROSS_BORDER_DISPLACED_PERSONS = 195,
    SCHOOL_SHIFT = 196,
    STRATUM = 198,
    PROMOTION_PROGRAMS = 199,
    CULTURE_SPORTS_RECREATION_SECTOR_ENTITIES = 200,
    CULTURAL_EQUIPMENT = 202,
    APPROACHES = 203,
    ATTENTION_MODALITY = 204,
    STRATEGIC_LINES = 205,
    CULTURED_CATEGORY = 206,
    CULTURED_SUB_CATEGORIES = 207,
    SICON_STATES = 209,
    SICON_MODALITIES = 210,
    PROFILES = 211,

    PAYMENT_METHODS = 6,
    SOCIAL_GROUPS = 7,
    SOCIAL_SECTORS = 8,
    DAYS_OF_THE_WEEK = 11,
    EVENTS_TYPES = 12,
    PUBLIC_ROLE = 19,
    INSTITUTIONAL_SECTOR = 20,
    ACTUACION_LEVEL = 21,
    TIPO_APOYO = 22,
    INSTRUMENTOS_GESTION = 23,
    APOYO_ACCESIBILIDAD = 25,
    POBLACION_PERFIL_PUBLICO = 26,
    EDUCATIVE_ROLE = 27,
    TIPO_INSTITUCION_EDUCATIVA = 28,
    NATURALEZA_INSTITUCION_EDUCATIVA = 29,
    NIVEL_INSTITUCION_EDUCATIVA = 30,
    PROGRAMAS_CULTURALES_EDUCATIVO = 31,
    ARTISAN_TRADE = 13,
    STATUS_HACEDORES = 16
}
export enum PaymentMethodsEnum {
    GRATIS = 322,
    DONACION = 323,
    PAGO = 324,
}
export enum ModeEnum {
    PRESENCIAL = 331,
    VIRTUAL = 332,
    MIXTO = 333,
}